import React, { useState, useEffect } from "react";
import { formatCurrency } from "./Format";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";

const FormattedInput = ({ value, onChange, type = "currency", className = "" }) => {
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleFocus = () => {
        setInputValue(inputValue);
    };

    const handleBlur = () => {
        if (type === "currency") {
            onChange(parseFloat(inputValue) || 0);
        } else if (type === "text") {
            onChange(inputValue);
        }
    };

    return type === "date" ? (
        <DatePickerComponent
            value={value ? new Date(value) : null}
            format="dd/MM/yyyy"
            placeholder="Sélectionner une date"
            onChange={(e) => onChange(e.value ? e.value.toISOString().split("T")[0] : "")}
            className={`${className}`}
        />
    ) : type === "text" ? (
        <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={handleBlur}
            onFocus={handleFocus}
            className={`border-gray-300 p-1 cursor-pointer border rounded focus:ring-2 ring-orange-500 text-center outline-none ${className}`}
        />
    ) : (
        <input
            type="text"
            value={formatCurrency(inputValue)}
            onChange={(e) => setInputValue(e.target.value)}
            onFocus={handleFocus}
            onBlur={handleBlur}
            className={`border-gray-300 p-1 cursor-pointer border rounded focus:ring-2 text-center outline-none ${className}`}
        />
    );
};

export default FormattedInput;
